import React from "react";
import ExamRequestViewState, { ExamRequestViewProps } from "./ExamRequestView.models";
import './ExamRequestView.css';
import ExamResultService from "../../../services/exam/ExamResultService";
import { WordRestrictions } from "../../../models/extension/WordExtention";

export default class ExamRequestView extends React.PureComponent<ExamRequestViewProps, ExamRequestViewState> {

    examResultService: ExamResultService;
    constructor(props: any) {
        super(props);
        this.examResultService = new ExamResultService();
        this.state = {
            requestedExam: {}
        }
    }

    componentDidMount() {
        let self = this;

        self.setState({ requestedExam: this.props.requestedExam });
    }

    componentDidUpdate() {
        let self = this;

        self.setState({ requestedExam: this.props.requestedExam });
    }

    cancelRequest = (requestId?: number) => {
        this.props.removeRequest(requestId);
    }

    render(): React.ReactNode {
        let exam = this.state.requestedExam;
        let cancelRequestExamButton;

        if (this.state.requestedExam.isConfirmation == null) {
            cancelRequestExamButton = (<div className="col-3 notspace">
                <button onClick={() => this.cancelRequest(exam.requestId)} className="cancelBox" style={{ outline: "none" }}>
                    لغو
                </button>
            </div>)
        }
        else {
            cancelRequestExamButton = "";
        }

        return <>
            <div className="mb-2 box-shadow exam-request-view-area">
                <div className="tk-inline card-boundel">
                    <div className="col-2 notspace">
                        <div className={exam.isConfirmation == null ? "icon pendding-images" : exam.isConfirmation === true ? "icon success-images" : "icon danger-images"}>
                            <label className={exam.isConfirmation == null ? "mdi mdi-progress-clock" : exam.isConfirmation === true ? "mdi mdi-progress-check" : "mdi mdi-progress-close"}></label>
                        </div>
                    </div>
                    <div className="col-7 notspace" style={{ textAlign: "right", marginRight: "20px" }} >
                        {/* @onclick="()=>showDetailExam(exam.requestId)" */}
                        <div className="pd-detail">
                            <div className="title tk-tooltip">
                                <label>{exam.requestTitle !== undefined ? WordRestrictions(exam.requestTitle,15) : ''}</label>
                                <label className="tk-tooltiptext buttom">{exam.requestTitle}</label>
                            </div>
                            <div className="subtitle">
                                <label>{exam.isConfirmation == null ? "در حال پردازش" : exam.isConfirmation === true ? "تایید شده " : "تایید نشده"}</label>
                            </div>
                        </div>
                    </div>
                    {cancelRequestExamButton}
                </div>
            </div>
        </>;
    }
}